export default function LocationPin({ text }) {
	return (
		<div className="pin">
			<p className="pin-text">{text}</p>
		</div>
	);
}
